// External library
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

// Component
export default class KangaScroll {
    constructor () {
        this.stickyScroll = document.querySelectorAll('[data-kanga-scroll]')

        // If there's no kanga scroll component
        if (!this.stickyScroll)
            return

        this.stickyScroll.forEach(scrollEl => this.animationSetup(scrollEl))
    }

    animationSetup (scrollEl) {
        const stickySections = gsap.utils.toArray(
            scrollEl.querySelectorAll('.kanga-text-media-scroll-row')
        )

        const scrollRows = scrollEl.querySelector('.kanga-text-media-scroll-rows')

        // If there's less than two kanga scroll component
        if (!stickySections || stickySections.length < 2)
            return

        // Save styles to be restored in mobile
        const preserveStyles = [
            '.kanga-text-media-scroll-row',
            '.kanga-text-media-scroll-rows',
            '.text-media-asset',
            '.text-media-content'
        ]

        ScrollTrigger.saveStyles(preserveStyles)

        ScrollTrigger.matchMedia({
            '(min-width: 992px)': () => {
                const height = 100 * stickySections.length

                const stickyTimeline = gsap.timeline({
                    duration: stickySections.length,
                    scrollTrigger: {
                        trigger: scrollEl,
                        start: 'top top',
                        end: '+=' + height + '%',
                        id: 'stickySections',
                        scrub: true
                    }
                })

                gsap.timeline({
                    scrollTrigger: {
                        trigger: scrollRows,
                        start: 'top top',
                        end: '+=' + height + '%',
                        pin: scrollRows,
                        id: 'pinning',
                        scrub: true,
                        pinSpacing: true,
                        smooth: true
                    }
                })

                stickySections.forEach(function (el, i) {
                    const mediaEl = el.querySelector('.text-media-asset')
                    const textEl = el.querySelector('.text-media-content')
                    const videoEl = mediaEl.querySelector('video')

                    const restartVideo = (video) => {
                        video.pause()
                        video.currentTime = 0
                        video.play()
                    }

                    gsap.set(el, {
                        position: 'absolute',
                        top: 0
                    })

                    stickyTimeline.from(mediaEl, {
                        onStart: () => videoEl
                            && restartVideo(videoEl)
                    }, i)

                    stickyTimeline.from(textEl, {
                        y: i === 0
                            ? '80%'
                            : '100%',
                        ease: 'easeIn'
                    }, i)

                    if (i !== 0)
                        stickyTimeline.from(mediaEl, {
                            autoAlpha: 0,
                            duration: 0.2,
                            y: 40,
                            ease: 'easeIn'
                        }, i)

                    if (i !== stickySections.length - 1) {
                        const timing = i + 0.75

                        stickyTimeline.to(mediaEl, {
                            autoAlpha: 0,
                            y: 0
                        }, timing)

                        stickyTimeline.to(textEl, {
                            y: '-100%'
                        }, timing)
                    }
                })
            }
        })
    }
}
